var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditIcon = function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.516 3.676 12.29 1.442a1.62 1.62 0 0 0-2.161-.057l-7.313 7.34a1.63 1.63 0 0 0-.463.986l-.35 3.4a.82.82 0 0 0 .501.829q.15.06.312.06h.073l3.388-.31c.371-.037.718-.201.983-.465l7.313-7.339a1.57 1.57 0 0 0-.057-2.21M6.131 12.06l-2.438.229.22-2.447 4.59-4.55 2.194 2.202zM11.754 6.4 9.576 4.215l1.584-1.631L13.38 4.81z"
  })));
};
export default SvgEditIcon;